module.exports = {
	"notification.message": "Wix.com आपको हर संभव सर्वश्रेष्ठ अनुभव प्रदान करने के लिए कुकीज़ का उपयोग करता है।",
	"notification.got.it": "समझ गए",
	"notification.more.info": "और अधिक पढ़ें"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_hi.json
// module id = 42
// module chunks = 0